import { render, staticRenderFns } from "./categoryDetail.vue?vue&type=template&id=1b15c442&scoped=true"
import script from "./categoryDetail.vue?vue&type=script&lang=js"
export * from "./categoryDetail.vue?vue&type=script&lang=js"
import style0 from "./categoryDetail.vue?vue&type=style&index=0&id=1b15c442&prod&lang=scss"
import style1 from "./categoryDetail.vue?vue&type=style&index=1&id=1b15c442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15c442",
  null
  
)

export default component.exports